import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: 'full',
            marginY: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            minHeight: {base: remCalc(576), sm: remCalc(460), md: remCalc(548), lg: remCalc(1024)},
            flexDirection: {base: 'column', lg: 'row'},
            justify: 'space-between',
            align: 'center',
            gap: 0,
            transition: 'all 0.5s ease-in-out',
        },
        addIcon: {
            color: 'foreground.neutral.inverse',
            boxSize: {base: 'iconsSize.large', lg: 'iconsSize.xlarge'},
            _groupHover: {
                color: 'foreground.neutral.default',
            },
            _groupFocusVisible: {
                color: 'foreground.neutral.default',
            },
        },
        subtitle: {
            color: 'foreground.neutral.inverse',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            textTransform: 'uppercase',
        },
        text: {
            color: 'foreground.neutral.inverse',
            textStyle: 'body-large',
            fontWeight: 'normal',
        },
        title: {
            color: 'foreground.neutral.inverse',
            textStyle: 'head-medium',
            fontWeight: 'medium',
            fontFamily: 'heading',
        },
        card: {
            gap: remCalc(24),
            alignItems: 'center',
            flex: 1,
            w: {base: '100%', lg: 'auto'},
            flexDirection: {base: 'row', lg: 'column'},
        },
        cardContainer: {
            w: {base: '100%', lg: 'auto'},
            borderStyle: 'solid',
            borderColor: {base: 'foreground.neutral.inverse', lg: 'foreground.neutral.inverse'},
            transition: 'all 0.5s ease-in-out',
            justifyContent: 'center',
            position: 'relative',
            h: '100%',
            _hover: {
                backgroundColor: 'rgba(0, 0, 0, 0.50)',
            },
        },
        closeIconOuterContainer: {
            position: 'absolute',
            top: {
                base: remCalc(24),
                md: remCalc(24),
                lg: remCalc(24),
                xl: remCalc(40),
            },
            right: {
                base: remCalc(16),
                md: remCalc(24),
                lg: remCalc(24),
                xl: remCalc(24),
            },
        },
        closeIconInnerContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSize: {base: 'iconsSize.medium', md: 'iconsSize.large', xl: 'iconsSize.xlarge'},
            _groupFocusWithin: {
                outline: 'none',
                boxShadow: 'none',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'var(--chakra-colors-background-default)',
            },
            _focusVisible: {
                outline: 'none',
                boxShadow: 'none',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'var(--chakra-colors-background-default)',
            },
        },
        closeIcon: {
            boxSize: {base: remCalc(15), md: remCalc(20), xl: 'iconsSize.medium'},
        },
        chevronRight: {
            boxSize: 'iconsSize.medium',
            pointerEvents: 'none',
        },
        selectedCard: {
            alignItems: 'start',
            gap: {base: remCalc(16), md: remCalc(8), lg: remCalc(24)},
        },
        mobileCard: {
            w: '100%',
            justifyContent: 'space-between',
        },
        selectedContainer: {
            display: 'flex',
            flexDirection: {base: 'column', lg: 'row'},
            transition: 'all 0.0001s',
        },
        mobileSelectedContainer: {
            gap: remCalc(16),
            justifyContent: 'space-between',
        },
        mobileClosedCard: {
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        fullContainer: {
            w: '100%',
        },
        buttonVariant: {
            variant: 'link-button',
        },
    },
}
